interface PaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

function getPageNumbers(page: number, totalPages: number): (number | '...')[] {
    const delta = 2;
    const range: number[] = [];
    for (let i = Math.max(2, page - delta); i <= Math.min(totalPages - 1, page + delta); i++) {
        range.push(i);
    }

    const pages: (number | '...')[] = [1];

    if (range[0] > 2) pages.push('...');
    pages.push(...range);
    if (range[range.length - 1] < totalPages - 1) pages.push('...');

    if (totalPages > 1) pages.push(totalPages);

    return pages;
}

const Pagination = ({ page, totalPages, onPageChange }: PaginationProps) => {
    if (totalPages <= 1) return null;
    const pages = getPageNumbers(page, totalPages);
    return (
        <nav>
            <ul className="pagination">
                <li>
                    <button type="button" disabled={page === 1} onClick={() => onPageChange(page - 1)}>&laquo;</button>
                </li>
                {pages.map((n, i) =>
                    n === '...'
                        ? <li key={`ellipsis-${i}`}><span>&hellip;</span></li>
                        : <li key={n} className={n === page ? 'active' : ''}>
                            <button type="button" disabled={n === page} onClick={() => onPageChange(n)}>{n}</button>
                          </li>
                )}
                <li>
                    <button type="button" disabled={page === totalPages} onClick={() => onPageChange(page + 1)}>&raquo;</button>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
